import { TaxResult } from 'src/app/modules/portfolio/models/taxResult';
import { SecurityTaxResultItemNestedObjectResponse } from '../../../../web-api-client';

export const mapTaxResultFromResponse = (
  taxItems: SecurityTaxResultItemNestedObjectResponse[]
): TaxResult[] => {
  return taxItems
    .map<TaxResult>(
      item =>
        new TaxResult({
          transactionTypeName: item.taxResultItemType?.name,
          description: item.description,
          rate: item.rate,
          securityTaxResultItemId: item.securityTaxResultItemId,
          taxResultItemTypeId: item.taxResultItemType?.taxResultItemTypeId,
          taxPolicyId: item.taxPolicyId,
          taxRuleId: item.taxRuleId,
          taxResultItemId: item.taxResultItemId,
        })
    )
    .sort(
      (a, b) =>
        a.taxResultItemTypeId! - b.taxResultItemTypeId! || a.rate! - b.rate!
    );
};
